export const LANGUAGES = Object.freeze([
  ['ca', 'Català'], ['es', 'Castellà'], ['en', 'Anglès'], ['de', 'Alemany'], ['ar', 'Àrab'],
  ['eu', 'Basc'], ['gl', 'Gallec'], ['fr', 'Francès'], ['it', 'Italià'], ['pt', 'Portuguès'],
  ['nl', 'Holandès'], ['pl', 'Polonès'], ['ro', 'Romanès'], ['ru', 'Rus'], ['uk', 'Ucraïnès'],
  ['zh', 'Xinès'], ['ja', 'Japonès'], ['ko', 'Coreà'], ['hi', 'Hindi'], ['tr', 'Turc'],
]);

export const PREMIUM_LANGUAGE_COUNT = LANGUAGES.filter(([code]) => code !== 'ca').length;
